module.exports = __webpack_public_path__ + "media/images/rate-poor-7873614c.png";